import type { Config } from 'dompurify'

export type PurifierConfig = Config & { RETURN_DOM_FRAGMENT?: false | undefined; RETURN_DOM?: false | undefined }

export const unicodeRegexp: string =
  '[^‐A-Za-z0-9  \\r\\n\\t@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ!"#¤%&\'()*+,\\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\\\\\[~\\]|€–—ç`’´‘′″“‑−一«»”！：•®οκ]'

export const emptyStringFallback = '-'
export const nameHighlightIgnoredChars = [' ', '-', '—', '(', ')']
